import Axios from "axios";
import { INVITED_BASE_URL } from "../common";

const appEnv = process.env.APP_ENV;

const axios = Axios.create({
  baseURL: `${INVITED_BASE_URL}/api/user`,
  withCredentials: appEnv === "prod" || appEnv === "staging" ? false : true,
});

const signUp = (
  displayName: string,
  email: string,
  password: string,
  token: string
) =>
  axios.post<void>("/sign-up", {
    display_name: displayName,
    email: email,
    password: password,
    captcha_token: token,
  });

interface SignInResponse {
  email: string;
  username: string;
  user_id: string;
  verified: boolean;
  created_at_iso_string: string;
}

const signIn = (email: string, password: string) =>
  axios.post<SignInResponse>("/sign-in", {
    email: email,
    password: password,
  });

const signOut = () => axios.post<void>("/sign-out");

interface GetUserResponse {
  id: string;
  email: string;
  username: string;
  display_name: string;
  color: string;
  profile_image_url: string;
  verified: boolean;
  created_at_iso_string: string;
  current_period_end: string;
  payment_plan: number;
}

const getUser = () => axios.get<GetUserResponse>("/");

interface UpdateDnameResponse {
  display_name: string;
}

const updateEmail = (email: string, token: string) =>
  axios.post("/update-email", {
    email: email,
    captcha_token: token
  });

const updateDisplayName = (displayName: string) =>
  axios.post<UpdateDnameResponse>("/display-name", {
    display_name: displayName,
  });

const updatePassword = (currPass: string, newPass: string) =>
  axios.post<void>("/update-password", {
    curr_password: currPass,
    new_password: newPass,
  });

interface VerifyAccountResponse {
  verified: boolean;
}
const verifyAccount = (code: string) =>
  axios.post<VerifyAccountResponse>(`/verify-account`, { code: code });

interface ProfileImageResponse {
  profile_image_url: string;
}

const updateProfileImage = (formData: FormData) =>
  axios.post<ProfileImageResponse>("/profile-image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

const updateColor = (color: string) => axios.post<void>("/color", { color });

const sendPasswordResetEmail = (email: string, captchaToken?: string) =>
  axios.post<void>("/send-password-reset-email", {
    email: email,
    ...(captchaToken && { captcha_token: captchaToken }),
  });

const sendAccountVerificationEmail = () =>
  axios.post<void>("/send-account-verification-email");

const resetPassword = (pass: string, token: string) =>
  axios.post<void>("/reset-password", {
    password: pass,
    token: token,
  });

const deleteAccount = (pass: string) =>
  axios.post<void>("/delete-account", { curr_password: pass });

export default {
  signUp,
  signIn,
  signOut,
  getUser,
  updateEmail,
  updateDisplayName,
  updatePassword,
  updateProfileImage,
  updateColor,
  sendPasswordResetEmail,
  verifyAccount,
  sendAccountVerificationEmail,
  resetPassword,
  deleteAccount,
};
